import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import {
    TrialInstitutionItemTemplateCategoryBreadcrumbs,
    TrialInstitutionItemTemplateCategoryCreateBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import { SettingsTrialInstitutionSubMenu } from "src/helpers/subMenuHelper";
import useNavigate from "src/hooks/useNavigate";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialInstitutionItemTemplateCategoriesActions from "../../../actions/trialInstitutionItemTemplateCategories";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    NumberFormInput,
    TextFormInput,
} from "../../../components/form/index";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { TrialLookupsLayout } from "../../index";

import "./TrialInstitutionItemTemplateCategoryPage.scss";

interface TrialInstitutionItemTemplateCategoryPageProps {
    form: Dtos.TrialInstitutionItemTemplateCategory & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    trialInstitutionItemTemplateCategory: Dtos.TrialInstitutionItemTemplateCategory;
    lookups: Dtos.Lookup[];
    loadingTrialInstitutionItemTemplateCategory: boolean;
    loadTrialInstitutionItemTemplateCategoryFailure: boolean;
    loadTrialInstitutionItemTemplateCategoryErrorCode: string;
    savingTrialInstitutionItemTemplateCategory: boolean;
    saveTrialInstitutionItemTemplateCategorySuccess: boolean;
    saveTrialInstitutionItemTemplateCategoryFailure: boolean;
    creatingTrialInstitutionItemTemplateCategory: boolean;
    createTrialInstitutionItemTemplateCategorySuccess: boolean;
    validatingTrialInstitutionItemTemplateCategory: boolean;
    validationFailures: Dtos.ResponseError[];
    permissions?: Dtos.PersonnelTmdPermissions[];
    clearTrialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategoriesActions.ITrialInstitutionItemTemplateCategoryClearActionCreator;
    loadTrialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategoriesActions.ITrialInstitutionItemTemplateCategoryLoadByIdActionCreator;
    saveTrialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategoriesActions.ITrialInstitutionItemTemplateCategorySaveActionCreator;
    createTrialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategoriesActions.ITrialInstitutionItemTemplateCategoryCreateActionCreator;
    validateTrialInstitutionItemTemplateCategory: TrialInstitutionItemTemplateCategoriesActions.ITrialInstitutionItemTemplateCategoryValidateActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.trialInstitutionItemTemplateCategory";

const TrialInstitutionItemTemplateCategoryPage: FC<
    TrialInstitutionItemTemplateCategoryPageProps
> = ({
    form,
    formState,
    formProperties,
    trialInstitutionItemTemplateCategory,
    lookups,
    loadingTrialInstitutionItemTemplateCategory,
    loadTrialInstitutionItemTemplateCategoryFailure,
    loadTrialInstitutionItemTemplateCategoryErrorCode,
    savingTrialInstitutionItemTemplateCategory,
    saveTrialInstitutionItemTemplateCategorySuccess,
    saveTrialInstitutionItemTemplateCategoryFailure,
    creatingTrialInstitutionItemTemplateCategory,
    createTrialInstitutionItemTemplateCategorySuccess,
    validatingTrialInstitutionItemTemplateCategory,
    validationFailures,
    permissions,
    clearTrialInstitutionItemTemplateCategory,
    loadTrialInstitutionItemTemplateCategory,
    saveTrialInstitutionItemTemplateCategory,
    createTrialInstitutionItemTemplateCategory,
    validateTrialInstitutionItemTemplateCategory,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { trialInstitutionItemTemplateCategoryId } = useParams<{
        trialInstitutionItemTemplateCategoryId: string;
    }>();
    const trialInstitutionItemTemplateCategoryIdNumber = parseInt(
        trialInstitutionItemTemplateCategoryId,
        10
    );

    //
    // -- Hooks --
    const navigate = useNavigate();

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [initalised, setInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    const loadReduxForm = () => {
        let extraData: Dtos.TrialInstitutionItemTemplateCategory =
            {} as Dtos.TrialInstitutionItemTemplateCategory;

        loadForm(
            reduxFormName,
            Object.assign(
                { ...trialInstitutionItemTemplateCategory },
                extraData
            )
        );
    };


    // Load trial institution item template category
    useEffect(() => {
        if (
            trialInstitutionItemTemplateCategoryIdNumber &&
            !trialInstitutionItemTemplateCategory &&
            !loadingTrialInstitutionItemTemplateCategory
        ) {
            setDrawerItems(SettingsTrialInstitutionSubMenu(permissions));
            setBreadcrumbs(
                TrialInstitutionItemTemplateCategoryBreadcrumbs(
                    trialInstitutionItemTemplateCategoryIdNumber
                )
            );
            loadTrialInstitutionItemTemplateCategory(
                trialInstitutionItemTemplateCategoryIdNumber
            );
        } else if (
            !trialInstitutionItemTemplateCategoryIdNumber &&
            !creatingTrialInstitutionItemTemplateCategory &&
            !createTrialInstitutionItemTemplateCategorySuccess
        ) {
            createTrialInstitutionItemTemplateCategory();
            setBreadcrumbs(
                TrialInstitutionItemTemplateCategoryCreateBreadcrumbs()
            );
            setDrawerItems([]);
        } else if (trialInstitutionItemTemplateCategory && !initalised) {
            loadReduxForm();
            setInitalised(true);
        }
    }, [
        trialInstitutionItemTemplateCategoryIdNumber,
        trialInstitutionItemTemplateCategory,
        setDrawerItems,
        SettingsTrialInstitutionSubMenu,
        permissions,
        setBreadcrumbs,
        TrialInstitutionItemTemplateCategoryBreadcrumbs,
        loadTrialInstitutionItemTemplateCategory,
        createTrialInstitutionItemTemplateCategory,
        initalised,
        setInitalised,
        loadReduxForm,
        loadingTrialInstitutionItemTemplateCategory,
        creatingTrialInstitutionItemTemplateCategory,
        createTrialInstitutionItemTemplateCategorySuccess,
        TrialInstitutionItemTemplateCategoryCreateBreadcrumbs,
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadTrialInstitutionItemTemplateCategoryFailure) {
            navigate(
                `/error/${loadTrialInstitutionItemTemplateCategoryErrorCode}`
            );
        }
    }, [
        loadTrialInstitutionItemTemplateCategoryFailure,
        loadTrialInstitutionItemTemplateCategoryErrorCode,
        navigate,
    ]);

    // Update breadcrumbs
    useEffect(() => {
        if (
            trialInstitutionItemTemplateCategoryIdNumber &&
            trialInstitutionItemTemplateCategory?.value
        ) {
            setBreadcrumbs(
                TrialInstitutionItemTemplateCategoryBreadcrumbs(
                    trialInstitutionItemTemplateCategoryIdNumber,
                    trialInstitutionItemTemplateCategory?.value
                )
            );
        }
    }, [
        trialInstitutionItemTemplateCategoryIdNumber,
        trialInstitutionItemTemplateCategory,
        setBreadcrumbs,
        TrialInstitutionItemTemplateCategoryBreadcrumbs,
    ]);

    // Reload trial item template category after saving
    useEffect(() => {
        if (
            !savingTrialInstitutionItemTemplateCategory &&
            saveTrialInstitutionItemTemplateCategorySuccess
        ) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Trial institution item template category saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                let url: string =
                    "/settings/trialinstitution/itemtemplatecategories";
                navigate(url);
            } else if (!trialInstitutionItemTemplateCategoryIdNumber) {
                let url: string = `/settings/trialinstitution/itemtemplatecategories/${trialInstitutionItemTemplateCategory?.id}`;
                navigate(url);
                clearTrialInstitutionItemTemplateCategory();
            }
        }
    }, [
        savingTrialInstitutionItemTemplateCategory,
        saveTrialInstitutionItemTemplateCategorySuccess,
        trialInstitutionItemTemplateCategoryIdNumber,
        navigate,
        clearTrialInstitutionItemTemplateCategory,
        saveAndReturn,
        trialInstitutionItemTemplateCategory,
    ]);

    // Failed saving
    useEffect(() => {
        if (
            !savingTrialInstitutionItemTemplateCategory &&
            saveTrialInstitutionItemTemplateCategoryFailure
        ) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [
        savingTrialInstitutionItemTemplateCategory,
        saveTrialInstitutionItemTemplateCategoryFailure,
    ]);

    // Cleanup effect to clear the trial institution item template category on component unmount
    useEffect(() => {
        return () => {
            clearTrialInstitutionItemTemplateCategory();
            resetForm(reduxFormName);
        };
    }, [clearTrialInstitutionItemTemplateCategory, resetForm, reduxFormName]);

    const onCancel = () => {
        let url: string = "/settings/trialinstitution/itemtemplatecategories";
        navigate(url);
    };

    const handleOnSubmitFailed = (
        _data: Dtos.TrialInstitutionItemTemplateCategory
    ) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.TrialInstitutionItemTemplateCategory =
                {} as Dtos.TrialInstitutionItemTemplateCategory;

            await saveTrialInstitutionItemTemplateCategory(
                Object.assign({ ...data }, changes)
            );

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.TrialInstitutionItemTemplateCategory =
                {} as Dtos.TrialInstitutionItemTemplateCategory;

            if (
                form &&
                hasBeenSubmitted &&
                !validatingTrialInstitutionItemTemplateCategory
            ) {
                await validateTrialInstitutionItemTemplateCategory(
                    Object.assign({ ...form }, changes)
                );
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermission(
                form,
                permissions,
                Dtos.Permission.CategoriesUpdate,
                Dtos.Permission.CategoriesCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingTrialInstitutionItemTemplateCategory ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            detailsGroup: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Details</h1>
                        <div className="card card-shadow" style={{ zIndex: 1 }}>
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionItemTemplateCategory",
                                        {
                                            value: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: TextFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-2",
                                                fieldClassName:
                                                    "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionItemTemplateCategory",
                                        {
                                            rank: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: NumberFormInput,
                                                inputDisabled: formDisabled,
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName:
                                                    "col-form-label col-sm-4",
                                                fieldClassName:
                                                    "col-sm-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6 d-flex align-items-center">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionItemTemplateCategory",
                                        {
                                            active: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: CheckboxFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    label: "Active",
                                                },
                                                inputLabel: " ",
                                                groupClassName:
                                                    "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-sm-4",
                                                fieldClassName:
                                                    "col-sm-8 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <div>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, _event) => handleOnSubmit(val)}
                    onSubmitFailed={(val) => handleOnSubmitFailed(val)}
                >
                    {renderFormControls(
                        form,
                        "trialInstitutionItemTemplateCategory",
                        formComponents,
                        lookups,
                        validationFailures,
                        formProperties,
                        changeForm
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>

                        <button
                            disabled={formDisabled}
                            onClick={() => {
                                changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={onCancel}
                            className="btn btn-primary mr-2"
                        >
                            Cancel
                        </button>
                    </div>
                </Form>
            </div>
        );
    }, [
        form,
        permissions,
        savingTrialInstitutionItemTemplateCategory,
        formState,
        handleOnSubmit,
        handleOnSubmitFailed,
        lookups,
        validationFailures,
        formProperties,
        changeForm,
        onCancel,
    ]);

    return (
        <TrialLookupsLayout
            loading={loadingTrialInstitutionItemTemplateCategory}
            permission={
                Dtos.Permission.TrialInstitutionItemTemplateCategoriesView
            }
        >
            {renderContent}
        </TrialLookupsLayout>
    );
};

const mapStateToProps = (
    state: ITmdState
): Partial<TrialInstitutionItemTemplateCategoryPageProps> => {
    let trialInstitutionItemTemplateCategory:
        | Dtos.TrialInstitutionItemTemplateCategory
        | undefined = !(
        state.trialInstitutionItemTemplateCategory.formData instanceof Array
    )
        ? state.trialInstitutionItemTemplateCategory.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        trialInstitutionItemTemplateCategory:
            trialInstitutionItemTemplateCategory!,
        loadingTrialInstitutionItemTemplateCategory:
            state.trialInstitutionItemTemplateCategory.loadState &&
            state.trialInstitutionItemTemplateCategory.loadState.status ==
                RequestState.Pending,
        loadTrialInstitutionItemTemplateCategoryFailure:
            state.trialInstitutionItemTemplateCategory.loadState &&
            state.trialInstitutionItemTemplateCategory.loadState.status ==
                RequestState.Failure,
        loadTrialInstitutionItemTemplateCategoryErrorCode:
            state.trialInstitutionItemTemplateCategory.loadState.errorCode,
        savingTrialInstitutionItemTemplateCategory:
            state.trialInstitutionItemTemplateCategory.saveState &&
            state.trialInstitutionItemTemplateCategory.saveState.status ==
                RequestState.Pending,
        saveTrialInstitutionItemTemplateCategorySuccess:
            state.trialInstitutionItemTemplateCategory.saveState &&
            state.trialInstitutionItemTemplateCategory.saveState.status ==
                RequestState.Success,
        saveTrialInstitutionItemTemplateCategoryFailure:
            state.trialInstitutionItemTemplateCategory.saveState &&
            state.trialInstitutionItemTemplateCategory.saveState.status ==
                RequestState.Failure,
        creatingTrialInstitutionItemTemplateCategory:
            state.trialInstitutionItemTemplateCategory.createState &&
            state.trialInstitutionItemTemplateCategory.createState.status ==
                RequestState.Pending,
        createTrialInstitutionItemTemplateCategorySuccess:
            state.trialInstitutionItemTemplateCategory.createState &&
            state.trialInstitutionItemTemplateCategory.createState.status ==
                RequestState.Success,
        validatingTrialInstitutionItemTemplateCategory:
            state.trialInstitutionItemTemplateCategory.validateState &&
            state.trialInstitutionItemTemplateCategory.validateState.status ==
                RequestState.Pending,
        permissions: permissions,
        lookups: [],
        form: state.reduxForms.trialInstitutionItemTemplateCategory,
        formState: state.trialInstitutionItemTemplateCategory.formState,
        formProperties:
            state.trialInstitutionItemTemplateCategory.formProperties,
        validationFailures: trialInstitutionItemTemplateCategory
            ? state.trialInstitutionItemTemplateCategory.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (
    dispatch
): Partial<TrialInstitutionItemTemplateCategoryPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadTrialInstitutionItemTemplateCategory: bindActionCreators(
            TrialInstitutionItemTemplateCategoriesActions.LoadTrialInstitutionItemTemplateCategoryById,
            dispatch
        ),
        clearTrialInstitutionItemTemplateCategory: bindActionCreators(
            TrialInstitutionItemTemplateCategoriesActions.Clear,
            dispatch
        ),
        saveTrialInstitutionItemTemplateCategory: bindActionCreators(
            TrialInstitutionItemTemplateCategoriesActions.SaveTrialInstitutionItemTemplateCategory,
            dispatch
        ),
        createTrialInstitutionItemTemplateCategory: bindActionCreators(
            TrialInstitutionItemTemplateCategoriesActions.CreateTrialInstitutionItemTemplateCategory,
            dispatch
        ),
        validateTrialInstitutionItemTemplateCategory: bindActionCreators(
            TrialInstitutionItemTemplateCategoriesActions.ValidateTrialInstitutionItemTemplateCategory,
            dispatch
        ),
        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrialInstitutionItemTemplateCategoryPage);
